function encodeFormData(data) {
  return Object.keys(data)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join('&')
}

export function submitNetlifyForm(formName, data) {
  return fetch('/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: encodeFormData({ 'form-name': formName, ...data }),
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`Netlify form submission failed with status ${response.status}`)
    }
    return response
  })
}
